module.exports = __webpack_public_path__ + "static/img/38-中国地质大学附属中学.e900968.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/38-中国地质大学附属中学.png
// module id = CHSg
// module chunks = 0